const RiderMediaIndex = () => import('./views/RiderMediaIndex.vue')
const RiderMediaCreate = () => import('./views/RiderMediaCreate.vue')
const RiderMediaEdit = () => import('./views/RiderMediaEdit.vue')

export default [
  {
    path: 'media',
    name: 'riders.media.index',
    component: RiderMediaIndex
  },
  {
    path: 'media/create',
    name: 'riders.media.create',
    component: RiderMediaCreate
  },
  {
    path: 'media/:mediaId(\\d+)',
    name: 'riders.media.edit',
    component: RiderMediaEdit
  }
]
